// extracted by mini-css-extract-plugin
export default {"root":"IconCard_root__24+3P","icon":"IconCard_icon__A8WdO","plus":"IconCard_plus__WIMRy"};